import { IOrder } from '@/interfaces/order';
import { getFullAddress } from '@/utils/customerUtils';
import { formatThaiDate } from '@/utils/dataUtils';
import { getShippingFullAddress } from '@/utils/shippingAddressUtils';
import React from 'react';

interface IProps {
  code: string;
  data: IOrder;
}

const TemplateOrderInfo = ({ data }: IProps) => {
  return (
    <div className="flex flex-row gap-5 mb-4">
      <div className="basis-1/2">
        <p className="font-bold mb-1 bg-gray-300 text-black px-1 inline-block">
          BILL TO
        </p>
        <span className="text-xs"> (ขายให้)</span>
        <p className="font-bold text-xs">{data?.customer?.name}</p>
        <p className="text-xs max-w-[250px]">
          {getFullAddress(data?.customer) || ''}
        </p>
        <p className="max-w-[250px] text-xs">
          Tel.: {data?.customer?.phoneNumber || '-'}
        </p>
        <p className="max-w-[250px] text-xs">
          Tax ID: {data?.customer?.taxId || '-'}
        </p>
        <p className="max-w-[250px] text-xs">
          Branch: {data?.customer?.branchId || '00000'}
        </p>
      </div>
      <div className="basis-1/2">
        <p className="font-bold mb-1 bg-gray-300 text-black, px-1 inline-block">
          SHIP TO
        </p>
        <span className="text-xs"> (สถานที่จัดส่งสินค้า)</span>
        <p className="font-bold text-xs">{data?.shippingAddress?.name}</p>
        <p className="max-w-[250px] text-xs">
          {getShippingFullAddress(data?.shippingAddress) || ''}
        </p>
        <p className="max-w-[250px] text-xs  mt-3">
          Contact Name: {data?.shippingAddress?.email || '-'}
        </p>
        <p className="max-w-[250px] text-xs">
          Tel.: {data?.shippingAddress?.contactName || '-'}
        </p>
      </div>
      <div className="basis-1/3 text-xs">
        <div className="flex flex-row justify-between mb-0.5">
          <div className="font-bold">INV No.</div>
          <div>{data?.ivNo || '-'}</div>
        </div>
        <div className="flex flex-row justify-between text-xs mb-2">
          <div className="font-bold">DATE </div>
          <div>{formatThaiDate(data?.orderCreateDate)}</div>
        </div>
        <div className="flex flex-row justify-between  mb-0.5">
          <div className="font-bold">Div.</div>
          <div>{data?.businessUnitName || ''}</div>
        </div>
        <div className="flex flex-row justify-between  mb-0.5">
          <div className="font-bold">Cust. </div>
          <div>{data?.customer?.code || '-'}</div>
        </div>
      </div>
    </div>
  );
};

export default TemplateOrderInfo;
